import { render, staticRenderFns } from "./BrandDoughnutChart.vue?vue&type=template&id=18a9418f&"
import script from "./BrandDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./BrandDoughnutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports